import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { Box, Button, Typography } from '@material-ui/core';

import { toast } from 'react-toastify';
import BarberShopTitle from '../../components/BarberShopTitle';
import { useGetCompanyDetail } from '../../hooks/data/companies';
import { IOrderDataState, useOrder } from '../../hooks/order';
import {
  useCreateAppointment,
  useDeleteAppointment,
} from '../../hooks/data/appointments';
import { daysOfWeek } from '../../utils/constants';
import appointmentService from '../../services/appointmentService';
import { IAppointmentDTO } from '../../shared/interfaces/appointment-interfaces';
import LoadingButton from '../../components/LoadingButton';

type IParams = {
  id: string;
  slug: string;
};

const DeleteAppointment: React.FC = () => {
  const params = useParams<IParams>();
  const history = useHistory();

  const [appointment, setAppointment] = useState<IAppointmentDTO | undefined>();
  const [status, setStatus] = useState<'cancel' | 'notFound' | undefined>();

  const { data: companyData, status: companyDataStatus } = useGetCompanyDetail(
    params.slug,
  );

  const deleteAppointment = useDeleteAppointment({ id: params.id });

  const getAppointmentDetail = useCallback(async () => {
    try {
      const response = await appointmentService.detail(params.id);
      setAppointment(response.data);
    } catch (err: any) {
      if (err?.response?.status === 404) {
        setStatus('notFound');
      }
    }
  }, [params.id]);

  useEffect(() => {
    getAppointmentDetail();
  }, [getAppointmentDetail]);

  const handleSubmit = useCallback(async () => {
    try {
      await deleteAppointment.mutateAsync({});

      setStatus('cancel');
    } catch (err) {
      toast.error('Erro ao excluir agendamento.');
    }
  }, [deleteAppointment]);

  return (
    <Box
      maxWidth="720px"
      height="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      padding={3}
      textAlign="start"
      margin="auto"
    >
      {status ? (
        <Box width="100%" textAlign="center">
          <BarberShopTitle title={companyData?.company_name ?? ''} />
          {status === 'cancel' && (
            <Typography>Agendamento cancelado com sucesso</Typography>
          )}
          {status === 'notFound' && (
            <Typography>Agendamento cancelado ou não encontrado</Typography>
          )}

          <Button
            onClick={() => history.push(`/parceiro/${companyData?.slug}`)}
            variant="contained"
            color="primary"
            style={{ marginTop: '16px' }}
          >
            Agendar novo horário
          </Button>
        </Box>
      ) : (
        <>
          <Box width="100%">
            <BarberShopTitle title={companyData?.company_name ?? ''} />
            <Typography
              style={{ marginTop: '24px', display: 'block' }}
              variant="subtitle1"
            >
              Deseja cancelar seu agendamento?
            </Typography>
          </Box>
          <Typography variant="subtitle1">
            {`Você deseja cancelar o serviço de ${
              appointment?.service.service_name
            } para o dia ${appointment?.date.replaceAll('-', '/')}, das ${
              appointment?.start_time
            } às ${appointment?.end_time}?
        Confirme no botão abaixo.`}
          </Typography>

          <Box
            width="100%"
            marginTop="64px"
            marginBottom="40px"
            display="flex"
            justifyContent="center"
          >
            <LoadingButton
              onClick={handleSubmit}
              loading={deleteAppointment.status === 'loading'}
            >
              Cancelar agendamento
            </LoadingButton>
          </Box>
        </>
      )}
    </Box>
  );
};

export default DeleteAppointment;
